import { Fragment, useContext, useState } from "react"
import { Tab } from "./components";
import { RenderProvider } from "./utils";
import CreateNewCustomer from "../../Transaction/CreateNewCustomer";
import CreateNewEmployee from "../../Transaction/CreateNewEmployee";
import CreateNewVendor from "../../Transaction/CreateNewVendor";
import { HeaderMenu } from "components";
import ListShitSchedule from "pages/Card/Transaction/ShiftSchedule/ListShitSchedule";
import { PERMISION } from "security";
import { AuthContext } from "contexts";

enum TabsActive {
  SCHEDULE = 0,
  EMPLOYEE = 1,
  CUSTOMER = 2,
  VENDOR = 3,
}

export default function All() {
  const { permission: list } = useContext(AuthContext)
  const [activeTab, setActiveTab] = useState<TabsActive | undefined>(Boolean(list.find((val) => val.startsWith(PERMISION.CARDS.REGISTER.SCHEDULE.PERMISION))) ? TabsActive.SCHEDULE : undefined);
  const tabs = [
    { name: "SCHEDULE", permission: PERMISION.CARDS.REGISTER.SCHEDULE.PERMISION },
    { name: "EMPLOYEE", permission: PERMISION.CARDS.REGISTER.EMPLOYEE.PERMISION },
    { name: "CUSTOMER", permission: PERMISION.CARDS.REGISTER.CUSTOMER.PERMISION },
    { name: "VENDOR", permission: PERMISION.CARDS.REGISTER.VENDOR.PERMISION }
  ]

  return (
    <Fragment>
      <section className="container my-5">
        <div className="sticky top-[36px] pt-1 z-[2] bg-white dark:bg-black">
          <HeaderMenu title="CARDS REGISTER"/>
        </div>
        <RenderProvider>
          <section className="w-full sticky top-[90px] pt-1 z-[2] bg-white dark:bg-black">
            <Tab tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
          </section>
          <section>
            {activeTab === TabsActive.SCHEDULE && <ListShitSchedule />}
            {activeTab === TabsActive.EMPLOYEE && <CreateNewEmployee tab="tab" />}
            {activeTab === TabsActive.CUSTOMER && <CreateNewCustomer tab="tab" />}
            {activeTab === TabsActive.VENDOR && <CreateNewVendor tab="tab" />}
          </section>
        </RenderProvider>
      </section>
    </Fragment>
  )
}